import { httpApi } from "api/http.api";
import { AxiosError } from "axios";

export const getPortalDetails = () => {
  const url = "/RawlingsMyLocker/GetPortalDetailsByStoreCode/MyLocker";
  return httpApi
    .get(url)
    .then((response) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};
